import toast from "react-hot-toast";
import * as api from "../Api";

export const createRequest = (postData) => async (dispatch) => {
  const fetchingId = toast.loading("Submitting data...");
  try {
    const { data } = await api.createRequest(postData);
    dispatch({ type: "CREATE_REQUEST", payload: data });
    toast.remove(fetchingId);
    toast.success("Request sent to head office");
    return data;
  } catch (error) {
    toast.remove(fetchingId);
    toast.error(error.response?.data?.message || "Request not sent");
    throw error;
  }
};

export const getRequest = () => async (dispatch) => {
  try {
    const { data } = await api.getRequest();
    dispatch({ type: "GET_ALL_REQUEST", payload: data });
  } catch (error) {}
};

export const deleteRequest = (id) => async (dispatch) => {
  const fetchingId = toast.loading("Withdrawing request...");
  try {
    await api.deleteRequest(id);
    dispatch({ type: "DELETE_REQUEST", payload: id });
    toast.remove(fetchingId);
    toast.success("Request withdrawn");
  } catch (error) {
    toast.remove(fetchingId);
    toast.error(error.response?.data?.message || "Couldn't withdraw the request");
  }
};

export const updateRequest = (id, postData) => async (dispatch) => {
  try {
    const fetchingId = toast.loading("updating data...");
    const { data } = await api.updateRequest(id, postData);
    dispatch({ type: "UPDATE_REQUEST", payload: data });
    toast.remove(fetchingId);
  } catch (error) {}
};
